import React, { useState, useRef } from "react";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { ReceiptNF } from "../../../../domain/models/receipt-model";
import { receiptsActions, ReceiptState } from "../store";
import { Badge, Grid, Paper, Stack, Typography } from "@mui/material";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";

interface FileUploaderProps {
  onFilesSelected: (files: FileList) => void;
}

const FileUploader: React.FC<FileUploaderProps> = ({ onFilesSelected }) => {
  const dispatch = useDispatch();

  const nfs: ReceiptNF[] = useSelector<ReceiptState, ReceiptNF[]>(
    (state) => state.data
  );

  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    onFilesSelected(files!);
  };

  const handleDragEnter = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragging(false);
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "copy";
    setIsDragging(true);
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragging(false);
    const files = event.dataTransfer.files;
    onFilesSelected(files);
  };

  const handleTraditionalUploadClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div
      className={`file-uploader ${isDragging ? "dragging" : ""}`}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      style={{
        padding: " 40px 0 40px 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "5px",
        backgroundColor: "#00000029",
      }}
    >
      <Stack direction={"row"} spacing={6} sx={{ my: "10px", width: "100%" }}>
        <Grid container rowSpacing={4} columnSpacing={4} sx={{ width: "100%" }}>
          {nfs.map((nf, index) => {
            return (
              <Grid
                item
                key={index}
                xs={3}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Badge
                  badgeContent={
                    <DeleteRoundedIcon
                      sx={{ fontSize: "12px", cursor: "pointer" }}
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(receiptsActions.removeNf({ nf }));
                      }}
                    />
                  }
                  color="primary"
                  key={index}
                >
                  <Paper
                    sx={{
                      width: "100px",
                      height: "50px",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography sx={{ width: "90%" }} fontSize={"10px"}>
                      {nf.reference}
                    </Typography>
                  </Paper>
                </Badge>
              </Grid>
            );
          })}
        </Grid>
      </Stack>
      <UploadFileRoundedIcon fontSize="large" />
      <p onClick={handleTraditionalUploadClick} style={{ cursor: "pointer" }}>
        Clique e selecione as notas fiscais, ou arraste-as e solte aqui
      </p>
      <input
        type="file"
        multiple
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
    </div>
  );
};

export default FileUploader;
